import { useId } from 'react'

/** United Kingdom — Union Jack (simplified). */
export function FlagUk({ className }: { className?: string }) {
  const clipId = useId().replace(/:/g, '')
  const href = `#${clipId}`
  return (
    <svg className={className} viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <clipPath id={clipId}>
        <path d="M0 0v30h60V0z" />
      </clipPath>
      <path fill="#012169" d="M0 0v30h60V0z" />
      <path d="M0 0l60 30m0-30L0 30" stroke="#fff" strokeWidth={6} clipPath={`url(${href})`} />
      <path d="M30 0v30M0 15h60" stroke="#fff" strokeWidth={10} clipPath={`url(${href})`} />
      <path d="M30 0v30M0 15h60" stroke="#C8102E" strokeWidth={6} clipPath={`url(${href})`} />
      <path d="M0 0l60 30m0-30L0 30" stroke="#C8102E" strokeWidth={4} clipPath={`url(${href})`} />
    </svg>
  )
}
